export default d => d
